<div class="main">
  <mat-toolbar color="primary" class="top">
    <a class="logo" [routerLink]="'manage/forms'">Coordinate Receiver</a>
    @if (loginService.getToken()) {
      <div class="logout" (click)="loginService.logout();">Logout</div>
    }

  </mat-toolbar>
  <div class="content">
    <mat-card>
      <mat-card-content>
        <router-outlet></router-outlet>
      </mat-card-content>
    </mat-card>
  </div>
  <mat-divider></mat-divider>
<!--  <mat-toolbar class="footer">
    <span>2025</span>
  </mat-toolbar>-->
</div>
